import { Button, ButtonProps, CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'

import { useAppDispatch } from '@/stores/hooks.ts'
import { useLogoutQuery } from '@/services'
import { APP_ROUTES } from '@/constants.ts'
import { resetAppKeepLastUserIdAction } from '@/stores'

export const LogoutButton = ({ size = 'small', onLogout }: { size?: ButtonProps['size']; onLogout?(): void }) => {
  const { refetch, isLoading } = useLogoutQuery()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const qc = useQueryClient()

  const handleLogout = async () => {
    const response = await refetch()
    if (response.isSuccess) {
      qc.removeQueries()
      dispatch(resetAppKeepLastUserIdAction())
      if (onLogout) {
        onLogout()
      }
      navigate(APP_ROUTES.Login)
    }
  }

  return (
    <Button color="secondary" onClick={handleLogout} sx={{ minWidth: 95 }} size={size} fullWidth>
      {isLoading ? <CircularProgress /> : 'Выйти'}
    </Button>
  )
}
